import type WindowFeaturesOptions from './store/schema/WindowFeaturesOptions';
import type { vDirType } from 'owa-vdir-types';
import type { MailboxInfo } from 'owa-client-types';

export default {
    PopoutAddPopout: {
        // Only store first section of route since the other parts may contain id which is PII.
        customData: (
            _mailboxInfo: MailboxInfo,
            _vdir: vDirType,
            route: string,
            _data?: object | (() => Promise<object>),
            _options?: Partial<WindowFeaturesOptions>,
            _skipOptinCheck?: boolean,
            actionSource?: string
        ): [string, string | undefined] => [(route || '').split('/')[0], actionSource],
    },
};
